import { gql } from 'graphql-request';

export const createSupportRequest = gql`
    mutation createSupportRequest($input: SupportRequestInput!) {
        createSupportRequest(input: $input)
    }
`;

export type CreateSupportRequestQueryResult = boolean;

export const myPreviousLoggedInTimeQuery = gql`
    query myPreviousLoggedInTime {
        myPreviousLoggedInTime
    }
`;

export type MyPreviousLoggedInTimeQueryResult = string;
